export const PROPERTY_TAB = {
    OCCUPANTS: 'Occupants',
    NON_MEMBERS: 'Non-Members',
    TENANTS: 'Tenants',
    GUESTS: 'Guests',
    VISITORS: 'Visitors',
    INVITED: 'Invited',
    DEVICES: 'Devices',
    VEHICLES: 'Vehicles',
    NOTES: 'Notes',
    RENTAL_MANAGERS: 'Rental Managers'
};

export const ORG_PROPERTY_TAB = {
    TEAM_MEMBERS: 'Team Members',
    MEMBERS: 'Members',
    GUESTS: 'Guests',
    ASSOCIATES: 'Associates',
    VISITORS: 'Visitors',
    INVITED: 'Invited',
    DEVICES: 'Devices',
    VEHICLES: 'Vehicles',
    CODES: 'Codes'
};

export const RESI_PROPERTY_STATUS = {
    PENDING: 'pending_approval',
    ACTIVE: 'active',
    INVITED: 'invited'
};
